import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavParams, LoadingController, AlertController, Platform } from '@ionic/angular';
import { OrderService } from './../../services/order.service';
import { CourierService } from './../../services/courier.service';
import { AuthService } from './../../services/auth.service';
import { APIService } from './../../services/api.service';
import { DateTimePickerPage } from './../../modals/date-time-picker/date-time-picker.page';
import { Printer } from '@capawesome-team/capacitor-printer';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { ObserverService } from '../../services/observer.service';
import { SupportedCurrencyService } from './../../services/supported-currency.service';
import * as printJS from 'print-js';
import { StorageService } from '../../services/storage.service';
import { Capacitor } from '@capacitor/core';
import { Decimal } from "decimal.js";

@Component({
    selector: 'app-order-fulfillment-add',
    templateUrl: './order-fulfillment-add.page.html',
    styleUrls: ['./order-fulfillment-add.page.scss'],
})

export class OrderFulfillmentAddPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    order_params = {};
    order_id = null;
    order = null;
    couriers = null;
    countries = null;
    date_modal_css_class = '';
    shipping_address_country = null;
    item_quantity = 0;
    formatted_date = null;
    fulfillable_items = [];
    base_currency = null;
    order_payment_owing = false;
    customer_amount_owing = false;
    customer_credit_limit_exceeded = false;
    on_device = false;
    printer_paper_sizes = [];

    fulfillment_params = {
        items: [],
        send_order_shipped_email: false,
        courier_id: '',
        courier_tracking_number: null
    }

    courier_select_options: any = {
        header: 'Courier'
    };

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private orderService: OrderService,
        private courierService: CourierService,
        private platform: Platform,
        private authService: AuthService,
        private apiService: APIService,
        private router: Router,
        private observerService: ObserverService,
        private supportedCurrencyService: SupportedCurrencyService,
        private storageService: StorageService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
            this.on_device = true;
        }

        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {
            if(printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }
        });

        if(this.navParams.get('order_id')) {

            this.order_id = this.navParams.get('order_id');

            this.fulfillment_params['date'] = this.moment().toISOString(true);
            this.formatted_date = this.moment(this.fulfillment_params['date']).format("D MMM YYYY, HH:mm");

            this.loadData().then(() => {

                if(this.order.person && this.order.person.email_address) {
                    this.fulfillment_params.send_order_shipped_email = true;
                }

                // TODO:
                // this.storageService.get("default_courier_id").then(default_courier_id => {
                //     this.fulfillment_params.courier_id = default_courier_id;
                // });

                for(let i = 0; i < this.order.items.length; i++) {
                    if(this.order.items[i].fulfillable_quantity != 0) {
                        let item = {};
                        item['id'] = this.order.items[i].id;
                        item['title'] = this.order.items[i].title;
                        item['fulfillable_quantity'] = this.order.items[i].fulfillable_quantity;
                        item['quantity'] = this.order.items[i].fulfillable_quantity;
                        item['quantity_decimal_places'] = this.order.items[i].quantity_decimal_places;

                        if(this.order.items[i].sku) {
                            item['sku'] = this.order.items[i].sku;
                        }

                        if(this.order.items[i].measurement_unit) {
                            item['measurement_unit'] = this.order.items[i].measurement_unit;
                        }

                        if(this.order.items[i].type == 1 && this.order.items[i].product) {
                            item['track_stock'] = this.order.items[i].product.track_stock;
                            item['stock_on_hand'] = this.order.items[i].product.stock_on_hand;
                        }
                        else if(this.order.items[i].type == 2 && this.order.items[i].sub_product) {
                            item['track_stock'] = this.order.items[i].sub_product.track_stock;
                            item['stock_on_hand'] = this.order.items[i].sub_product.stock_on_hand;
                        }

                        this.fulfillable_items.push(item);
                    }
                }

                if(this.order.payment_status != 'paid') {
                    this.order_payment_owing = true;
                }

                if(this.order.organisation) {
                    if(this.order.organisation.amount_owing > 0) {
                        this.customer_amount_owing = true;
                    }
                    if(this.order.organisation.credit_limit && this.order.organisation.amount_owing > this.order.organisation.credit_limit) {
                        this.customer_credit_limit_exceeded = true;
                    }
                }
                else if(this.order.person) {
                    if(this.order.person.amount_owing > 0) {
                        this.customer_amount_owing = true;
                    }
                    if(this.order.person.credit_limit && this.order.person.amount_owing > this.order.person.credit_limit) {
                        this.customer_credit_limit_exceeded = true;
                    }
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('network_status_changed|order_fulfillment_add_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to add a fulfillment, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|order_fulfillment_add_modal");
    }

    loadData() {

        return new Promise<void>((resolve, reject) => {

            this.presentSpinner("Loading order").then(() => {

                this.loadOrder().then(() => {

                    this.spinner.message = "Loading couriers";

                    this.loadCouriers().then(() => {

                        this.spinner.message = "Loading supported currency";

                        this.supportedCurrencyService.getBaseSupportedCurrency().then((base_currency) => {

                            if(base_currency) {
                                this.base_currency = base_currency;
                            }

                            this.spinner.dismiss();
                            resolve();

                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadOrder() {
        let promise = new Promise<void>((resolve, reject) => {
            this.order = null;
            this.orderService.getOrder(this.order_id).then((order) => {
                if(order) {
                    this.order = order;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    loadCouriers() {
        let promise = new Promise<void>((resolve, reject) => {
            this.couriers = null;
            this.courierService.getCouriers().then((couriers) => {
                if(couriers) {
                    this.couriers = couriers;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    // NOTE: always A4
    printPackingSlip() {
        this.presentSpinner('Printing packing slip').then(() => {
            
            let format = "";
            if(this.on_device) {
                format = "html";}
            else {
                format = "pdf_base64";
            }

            let items = [];
            for(let i = 0; i < this.fulfillable_items.length; i++) {
                let item = this.fulfillable_items[i];
                if(item['quantity'] > 0) {
                    items.push({
                        id: item['id'],
                        quantity: item['quantity']
                    });
                }
            }

            this.orderService.getOrderPackingSlip(this.order.id, format, items).then((packing_slip_content: any) => {
                if(packing_slip_content) {
                    if(this.on_device) {
                        Printer.printHtml({
                            name: 'Packing slip', 
                            html: packing_slip_content.replace('<html style="margin: 0; padding: 0; height: 100%;">', '<html style="margin: 0; padding: 20px; box-sizing: border-box; height: 100%;">')
                        });
                    }
                    else {
                        printJS({ 
                            printable: packing_slip_content, 
                            type: 'pdf', 
                            base64: true 
                        });
                    }
                }
            })
            .catch(() => {
                this.spinner.dismiss();
            })
            .finally(() => {
                this.spinner.dismiss();
            })
        });
    }

    close() {
        this.modalController.dismiss();
    }

    clearCourier() {
        this.fulfillment_params.courier_id = "";
    }

    adjustItemQuantity(item_id, change_mode){
        for(let i = 0; i < this.fulfillable_items.length; i++) {
            if(item_id == this.fulfillable_items[i].id) {
                let step = Math.pow(10, -this.fulfillable_items[i].quantity_decimal_places);
                if(change_mode === 'add'){
                    if(this.fulfillable_items[i].quantity < this.fulfillable_items[i].fulfillable_quantity){
                        this.fulfillable_items[i].quantity = Number(new Decimal(this.fulfillable_items[i].quantity).plus(step));
                    }
                }
                else if(change_mode === 'subtract'){
                    if(this.fulfillable_items[i].quantity > 0){
                        this.fulfillable_items[i].quantity = Number(new Decimal(this.fulfillable_items[i].quantity).minus(step));
                    }
                }
                break;
            }
        }
    }

   add() {

        let validated = true;
        let fulfillment_has_items = false;

        for(let i = 0; i < this.fulfillable_items.length; i++) {

            let item = this.fulfillable_items[i];
            let quantity_invalid_char = item.quantity.toString().search(/[^0-9.]/g);

            if(quantity_invalid_char == -1) {

                if(item.quantity > 0) {
                    fulfillment_has_items = true;
                }

                if(item.quantity > item.fulfillable_quantity){
                    this.presentAlert('Problem','Over fulfilled',`You have overfulfilled an item "${item.title}". The max quantity is ${item.fulfillable_quantity}.`);
                    validated = false;
                    break;
                }
                else if(item.quantity < 0) {
                    this.presentAlert('Problem','Negative quantity',`Item "${item.title}" has a negative quantity. Please make the quantity greater or equal to zero.`);
                    validated = false;
                    break;
                }
                else if(item.track_stock == 1 && item.quantity > item.stock_on_hand) {
                    this.presentAlert('Problem','Stock on hand exceeded',`Item "${item.title}" has a quantity that exceeds the stock on hand available to fulfill.`);
                    validated = false;
                    break;
                }

            }
            else {
                this.presentAlert('Problem','Invalid quantity',`Item "${item.title}" has an invalid quantity.`);
                validated = false;
                break;
            }

        }

        if(!fulfillment_has_items) {
            this.presentAlert('Problem','Empty fulfillment','You need at least one item.');
            validated = false;
        }

        if(validated) {

            let items = [];
            // change lookup into array
            for(let i = 0; i < this.fulfillable_items.length; i++) {
                if(this.fulfillable_items[i].quantity > 0) {
                    items.push({
                        id: this.fulfillable_items[i].id,
                        quantity: this.fulfillable_items[i].quantity
                    });
                }
            }

            this.fulfillment_params.items = items;
            this.fulfillment_params['date'] = moment(this.fulfillment_params['date']).utc().toISOString();

            this.addFulfillment().then(() => {
                this.modalController.dismiss();
            })
            .catch(() => { });

        }
    }

    addFulfillment() {
        let promise = new Promise<void>((resolve, reject) => {
            this.presentSpinner("Adding fulfillment").then(() => {
                this.orderService.addOrderFulfillment(this.order.id, this.fulfillment_params).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
        return promise;
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                componentProps: {
                    date: this.fulfillment_params['date'],
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.fulfillment_params['date'] = data.data['date'];
                    this.formatted_date = this.moment(this.fulfillment_params['date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
